import React, { useEffect, useRef, useState } from 'react';
import { SidebarCollapseContext } from './SidebarCollapseContext';
import { SidebarFlyoutContext } from './SidebarFlyoutContext';
import SidebarSeam from './SidebarSeam';
import './Sidebar.css';

const flyoutCloseDelayMs = 300;

interface IProps {
  collapsed?: boolean;
  onToggle?: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
}

export default function Sidebar({ collapsed = false, onToggle, header, footer, children }: IProps) {
  const [openKey, setOpenKey] = useState<string>();
  const closeTimer = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(closeTimer.current), []);

  const open = (key: string) => {
    clearTimeout(closeTimer.current);
    setOpenKey(key);
  };
  const closeSoon = () => {
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setOpenKey(undefined), flyoutCloseDelayMs);
  };
  const close = () => {
    clearTimeout(closeTimer.current);
    setOpenKey(undefined);
  };

  return (
    <SidebarCollapseContext.Provider value={{ collapsed }}>
      <SidebarFlyoutContext.Provider value={{ openKey, open, closeSoon, close }}>
        <nav
          className="navbar navbar-sidebar navbar-vertical navbar-light bg-white border-bottom border-end"
          style={{
            overflow: 'hidden',
            transition: 'width 0.2s ease-in-out, min-width 0.2s ease-in-out',
            ...(collapsed ? { width: 'var(--sidebar-collapsed-width)', minWidth: 'var(--sidebar-collapsed-width)' } : {}),
          }}>
          <div className="navbar-sidebar-aside-body pt-0 d-flex flex-column h-100" style={{ minHeight: 0 }}>
            {header &&
              <div
                className="sidebar-header flex-shrink-0 w-100 d-flex align-items-center justify-content-center px-2 bg-white"
                style={{ height: 'var(--header-height)' }}>
                {!collapsed && header}
              </div>}
            <ul
              className="navbar-nav nav nav-vertical nav-tabs nav-tabs-borderless sidebar-nav-scroll pt-0 flex-nowrap flex-fill w-100"
              style={{ minHeight: 0, overflowY: 'auto', overflowX: 'hidden', overscrollBehavior: 'contain' }}>
              {children}
            </ul>
            {footer && <div className="sidebar-footer flex-shrink-0 w-100 bg-white">{footer}</div>}
          </div>
        </nav>
        {onToggle && <SidebarSeam collapsed={collapsed} onToggle={onToggle} />}
      </SidebarFlyoutContext.Provider>
    </SidebarCollapseContext.Provider>
  );
}
